// src/utils/useAutoResizeTextareas.js
import { useEffect } from "react";

export default function useAutoResizeTextareas() {
  useEffect(() => {
    const resize = (ta) => {
      ta.style.height = "auto";
      const newH = Math.min(ta.scrollHeight, 160);
      ta.style.height = newH + "px";
    };

    const tAs = Array.from(document.querySelectorAll("textarea.auto-resize"));
    tAs.forEach(ta => {
      resize(ta);
      const handler = () => resize(ta);
      ta.addEventListener("input", handler);
      ta._autoResizeHandler = handler;
    });

    return () => {
      tAs.forEach(ta => {
        if (ta._autoResizeHandler) ta.removeEventListener("input", ta._autoResizeHandler);
      });
    };
  }, []);
}
